import type { EmployeeSnapshot } from '@klukka/client';
import { fmtDay, t, type LangCode, type LeaveRequest } from '@klukka/core';
import { Ic, StatusChip, Trail } from '@klukka/ui';

function spanOf(r: LeaveRequest, tr: (k: Parameters<typeof t>[1]) => string): string {
  const time = (x: string) => (x && x !== '00:00' && x !== '23:59' ? ` ${x}` : '');
  return `${tr('from')} ${fmtDay(r.from)}${time(r.fromTime)} · ${tr('to')} ${fmtDay(r.to)}${time(r.toTime)}`;
}

const TYPE_KEY = {
  sick: 'sick', leave: 'leave', open: 'openReq', vacation: 'vacation',
} as const;

export function RequestsTab({ snap, lang, onNew }: {
  snap: EmployeeSnapshot;
  lang: LangCode;
  onNew: () => void;
}) {
  const tr = (k: Parameters<typeof t>[1]) => t(lang, k);

  return (
    <div className="ph-body">
      <button className="btn-main" onClick={onNew}><Ic.plus size={16} /> {tr('newRequest')}</button>
      {snap.requests.length === 0 ? <div className="note-est">{tr('empty')}</div> : null}
      {snap.requests.map((r) => (
        <div className="card" key={r.id}>
          <div className="rowline">
            <span><b>{tr(TYPE_KEY[r.type])}</b></span>
            <StatusChip status={r.status} label={tr(r.status)} />
          </div>
          <div className="dimtx" style={{ fontSize: 13 }}>
            {r.type === 'open' ? r.note : spanOf(r, tr) + (r.note ? ` · ${r.note}` : '')}
          </div>
          <Trail trail={r.trail} />
        </div>
      ))}
    </div>
  );
}
